/**
 * @generated SignedSource<<d78fdaee85c226463132d0b52c09a79a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskArticlesSearchResults_viewer$data = {
  readonly zendeskArticles: {
    readonly articles?: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly snippet: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskArticlesSearchResults_viewer";
};
export type GetHelpZendeskArticlesSearchResults_viewer$key = {
  readonly " $data"?: GetHelpZendeskArticlesSearchResults_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticlesSearchResults_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasSearchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "searchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskArticlesSearchResults_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "condition": "hasSearchQuery",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "query",
                  "variableName": "searchQuery"
                }
              ],
              "concreteType": "ZendeskArticle",
              "kind": "LinkedField",
              "name": "articles",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "snippet",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5d2163b84f615df1f785fba54d0c2668";

export default node;
